"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfigProvider = exports.ConfigContext = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ConfigContext = exports.ConfigContext = /*#__PURE__*/_react.default.createContext(null);
const ConfigProvider = props => {
  const {
    children,
    config
  } = props;
  const providerConfig = (0, _react.useMemo)(() => ({
    config
  }), [config]);
  return /*#__PURE__*/_react.default.createElement(ConfigContext.Provider, {
    value: providerConfig
  }, children);
};
exports.ConfigProvider = ConfigProvider;